import {css} from 'lit';

export default css`

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
}
.btn:hover, .btn:focus {
  color: #022851;
  text-decoration: none;
}
.btn:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn, .dark-background .btn {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}

.btn--primary,
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  --btn-arrow-color: #ffbf00;
  padding-right: 1.5em;
  padding-left: 0.75em;
  transition: 0.2s padding ease-out;
  --btn-arrow-color: #fff;
  border-color: transparent;
  background-color: #ffbf00;
}
.btn--primary:hover, .btn--primary:focus,
.button:hover,
.button:focus {
  color: #022851;
  text-decoration: none;
}
.btn--primary:focus,
.button:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--primary, .dark-background .btn--primary,
.category-brand__background .button,
.dark-background .button {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--primary:before,
.button:before {
  width: 1em;
  color: var(--btn-arrow-color);
  content: '\\f054';
  font-family: "Font Awesome 5 Free";
  font-size: 0.75em;
  font-weight: 900;
  opacity: 0;
  transform: translateX(-100%);
  transition: 0.2s all ease-out;
}
.btn--primary:hover,
.button:hover {
  padding-right: 1.125em;
  padding-left: 1.125em;
}
.btn--primary:hover:before,
.button:hover:before {
  opacity: 1;
  transform: translateX(-45%);
}
.category-brand__background .btn--primary, .dark-background .btn--primary,
.category-brand__background .button,
.dark-background .button {
  --btn-arrow-color: var(--category-brand-featured, var(--category-brand, #13639e));
  border-color: transparent;
  background-color: #fff;
  color: var(--category-brand-featured, var(--category-brand, #13639e));
}
.category-brand__background .btn--primary:hover, .dark-background .btn--primary:hover,
.category-brand__background .button:hover,
.dark-background .button:hover {
  color: var(--category-brand-featured, var(--category-brand, #13639e));
}
.category-brand__background--lighten .btn--primary,
.category-brand__background--lighten .button {
  --btn-arrow-color: var(--category-brand-contrast-color, #fff);
  border-color: transparent;
  background-color: var(--category-brand, #ffbf00);
  color: var(--category-brand-contrast-color, #022851);
}
.category-brand__background--lighten .btn--primary:hover, .category-brand__background--lighten .btn--primary:active,
.category-brand__background--lighten .button:hover,
.category-brand__background--lighten .button:active {
  color: var(--category-brand-contrast-color, #022851);
}

.btn--primary-input,
.btn--primary:where(input),
.button:where(input) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  padding-right: 1.5em;
  padding-left: 1.5em;
  border-color: transparent;
  background-color: #ffbf00;
}
.btn--primary-input:hover, .btn--primary-input:focus,
.btn--primary:where(input):hover,
.btn--primary:where(input):focus,
.button:where(input):hover,
.button:where(input):focus {
  color: #022851;
  text-decoration: none;
}
.btn--primary-input:focus,
.btn--primary:where(input):focus,
.button:where(input):focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--primary-input, .dark-background .btn--primary-input,
.category-brand__background .btn--primary:where(input),
.dark-background .btn--primary:where(input),
.category-brand__background .button:where(input),
.dark-background .button:where(input) {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--primary-input:hover,
.btn--primary:where(input):hover,
.button:where(input):hover {
  padding-right: 1.5em;
  padding-left: 1.5em;
}
.category-brand__background .btn--primary-input, .dark-background .btn--primary-input,
.category-brand__background .btn--primary:where(input),
.dark-background .btn--primary:where(input),
.category-brand__background .button:where(input),
.dark-background .button:where(input) {
  border-color: transparent;
  background-color: #fff;
  color: var(--category-brand-featured, var(--category-brand, #13639e));
}
.category-brand__background .btn--primary-input:hover, .dark-background .btn--primary-input:hover,
.category-brand__background .btn--primary:where(input):hover,
.dark-background .btn--primary:where(input):hover,
.category-brand__background .button:where(input):hover,
.dark-background .button:where(input):hover {
  color: var(--category-brand-featured, var(--category-brand, #13639e));
}

.btn--alt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  --btn-arrow-color: #ffbf00;
  padding-right: 1.5em;
  padding-left: 0.75em;
  transition: 0.2s padding ease-out;
  border-color: transparent;
  background-color: #022851;
  color: #fff;
}
.btn--alt:hover, .btn--alt:focus {
  color: #022851;
  text-decoration: none;
}
.btn--alt:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--alt, .dark-background .btn--alt {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--alt:before {
  width: 1em;
  color: var(--btn-arrow-color);
  content: '\\f054';
  font-family: "Font Awesome 5 Free";
  font-size: 0.75em;
  font-weight: 900;
  opacity: 0;
  transform: translateX(-100%);
  transition: 0.2s all ease-out;
}
.btn--alt:hover {
  padding-right: 1.125em;
  padding-left: 1.125em;
}
.btn--alt:hover:before {
  opacity: 1;
  transform: translateX(-45%);
}
.btn--alt:hover, .btn--alt:focus {
  color: #fff;
}
.btn--alt:focus {
  box-shadow: 0 0 0 3px #ffbf00;
}
.category-brand__background .btn--alt, .dark-background .btn--alt {
  --btn-arrow-color: var(--category-brand-contrast-color);
  border: 2px solid var(--category-brand-contrast-color, #fff);
  background-color: transparent;
}
.category-brand__background .btn--alt:hover, .category-brand__background .btn--alt:focus, .dark-background .btn--alt:hover, .dark-background .btn--alt:focus {
  background-color: rgba(var(--category-brand-rgb--dark, transparent), 0.1);
}

.btn--alt2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  --btn-arrow-color: #ffbf00;
  padding-right: 1.5em;
  padding-left: 0.75em;
  transition: 0.2s padding ease-out;
  border-color: transparent;
  background-color: #022851;
  color: #fff;
  background-color: #13639e;
}
.btn--alt2:hover, .btn--alt2:focus {
  color: #022851;
  text-decoration: none;
}
.btn--alt2:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--alt2, .dark-background .btn--alt2 {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--alt2:before {
  width: 1em;
  color: var(--btn-arrow-color);
  content: '\\f054';
  font-family: "Font Awesome 5 Free";
  font-size: 0.75em;
  font-weight: 900;
  opacity: 0;
  transform: translateX(-100%);
  transition: 0.2s all ease-out;
}
.btn--alt2:hover {
  padding-right: 1.125em;
  padding-left: 1.125em;
}
.btn--alt2:hover:before {
  opacity: 1;
  transform: translateX(-45%);
}
.btn--alt2:hover, .btn--alt2:focus {
  color: #fff;
}
.btn--alt2:focus {
  box-shadow: 0 0 0 3px #ffbf00;
}
.category-brand__background .btn--alt2, .dark-background .btn--alt2 {
  --btn-arrow-color: var(--category-brand-contrast-color);
  border: 2px solid var(--category-brand-contrast-color, #fff);
  background-color: transparent;
}
.category-brand__background .btn--alt2:hover, .category-brand__background .btn--alt2:focus, .dark-background .btn--alt2:hover, .dark-background .btn--alt2:focus {
  background-color: rgba(var(--category-brand-rgb--dark, transparent), 0.1);
}

.btn--alt3 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  --btn-arrow-color: #ffbf00;
  padding-right: 1.5em;
  padding-left: 0.75em;
  transition: 0.2s padding ease-out;
  --btn-arrow-color: #13639e;
  border-color: transparent;
  background-color: #dbeaf7;
}
.btn--alt3:hover, .btn--alt3:focus {
  color: #022851;
  text-decoration: none;
}
.btn--alt3:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--alt3, .dark-background .btn--alt3 {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--alt3:before {
  width: 1em;
  color: var(--btn-arrow-color);
  content: '\\f054';
  font-family: "Font Awesome 5 Free";
  font-size: 0.75em;
  font-weight: 900;
  opacity: 0;
  transform: translateX(-100%);
  transition: 0.2s all ease-out;
}
.btn--alt3:hover {
  padding-right: 1.125em;
  padding-left: 1.125em;
}
.btn--alt3:hover:before {
  opacity: 1;
  transform: translateX(-45%);
}

.btn--invert {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 10ch;
  min-height: 2.5em;
  margin-bottom: 0;
  padding: 0.625em 1em;
  border: 1px solid #b0d0ed;
  background-color: transparent;
  color: #022851;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  --btn-arrow-color: #ffbf00;
  padding-right: 1.5em;
  padding-left: 0.75em;
  transition: 0.2s padding ease-out;
  --btn-arrow-color: var(--forced-contrast, #ffbf00);
  border-color: var(--forced-contrast, #ffbf00);
  background-color: transparent;
  color: var(--forced-contrast, #022851);
}
.btn--invert:hover, .btn--invert:focus {
  color: #022851;
  text-decoration: none;
}
.btn--invert:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px #022851;
  outline-color: transparent;
  outline-style: solid;
}
.category-brand__background .btn--invert, .dark-background .btn--invert {
  border-color: var(--category-brand-contrast-color);
  color: var(--category-brand-contrast-color);
}
.btn--invert:before {
  width: 1em;
  color: var(--btn-arrow-color);
  content: '\\f054';
  font-family: "Font Awesome 5 Free";
  font-size: 0.75em;
  font-weight: 900;
  opacity: 0;
  transform: translateX(-100%);
  transition: 0.2s all ease-out;
}
.btn--invert:hover {
  padding-right: 1.125em;
  padding-left: 1.125em;
}
.btn--invert:hover:before {
  opacity: 1;
  transform: translateX(-45%);
}
.btn--invert:hover, .btn--invert:focus {
  color: var(--forced-contrast, #022851);
}

.btn--disabled,
.btn[disabled],
[disabled] .btn {
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.3;
  pointer-events: none;
}

.btn--lg {
  font-size: 1.25rem;
}

.btn--sm {
  font-size: 0.875rem;
}

.btn--round {
  border-radius: 1.25em;
}

.btn--block {
  display: flex;
  width: 100%;
}

.btn--input {
  padding-right: 1em;
  padding-left: 1em;
}
.btn--input:hover {
  padding-right: 0.75em;
  padding-left: 0.75em;
}

`;